import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { EmailRecipient } from "../email/email.model";
import { EmailRecipientFilterService } from "../email/email.filter";

@Injectable({
  providedIn: "root"
})
export class RecipientService {
  public filter: EmailRecipientFilterService;
  public editing: EmailRecipient;

  public recipients$: Observable<EmailRecipient[]>;

  constructor(public db: AngularFirestore, public httpClient: HttpClient) {
    // this.filter = new EmailRecipientFilterService();
    // this.observe();
    // this.subscribe();
  }

  // observe() {
  //   this.recipients$ =
  // }
  // subscribe() {
  //   this.recipients$.subscribe(recips => this.filter.next(recips));
  // }
}
